'use strict';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var axios = require('axios').default;

var apiInstance = axios.create();
var statsInstance = axios.create();

var setRequestInterceptor = function setRequestInterceptor(callback, requestType) {
  var axiosInstance = requestType === 'searchApi' ? apiInstance : statsInstance;
  axiosInstance.interceptors.request.use(function (config) {
    var updatedConfig = callback({
      url: config.url,
      headers: config.headers
    });
    config = _objectSpread(_objectSpread({}, config), updatedConfig);
    return config;
  }, function (error) {
    return Promise.reject(error);
  });
};

module.exports = {
  apiInstance: apiInstance,
  statsInstance: statsInstance,
  setRequestInterceptor: setRequestInterceptor
};